module.exports = __webpack_public_path__ + "static/img/wawaBottom1.f2677cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wawaBottom1.png
// module id = WQZY
// module chunks = 2